import { render, staticRenderFns } from "./CopyStakeWhitelistView.vue?vue&type=template&id=c61bd646&scoped=true&lang=pug"
import script from "./CopyStakeWhitelistView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWhitelistView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWhitelistView.vue?vue&type=style&index=0&id=c61bd646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61bd646",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VIcon})
